import { createStore, compose, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { createBrowserHistory } from 'history';
// react-router-redux is no longer needed with React Router v6
// Routing is handled directly through React Router v6 hooks
import rootReducer from '../reducers';
import { createLogger } from 'redux-logger';

const logger = createLogger({
  // Guard against undefined actions to prevent destructuring errors
  predicate: (getState, action = {}) => !(action && typeof action.type === 'string' && action.type.includes('@redux-form')),
});

export const history = createBrowserHistory();

function configureStoreProd(initialState) {
  const middlewares = [thunk];

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middlewares))
  );
}

function configureStoreDev(initialState) {
  // Note: redux-immutable-state-invariant removed - incompatible with Redux 5
  // Redux 5 has built-in immutability checks in development mode
  const middlewares = [
    thunk,
    logger,
  ];

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

const configureStore =
  process.env.NODE_ENV === 'production'
    ? configureStoreProd
    : configureStoreDev;

export default configureStore;
